import { CcmStatuses, RpmStatuses } from 'infrastructure/enums';

export const disableCcmModuleStatuses = [
  CcmStatuses.NotEnrolled,
  CcmStatuses.CCMCallingQueue,
  CcmStatuses.CCMReferralReceived,
  CcmStatuses.CCMReferralOnHold,
  CcmStatuses.CCMReferralWithdrawn,
  CcmStatuses.CCMPatientNoContact,
  CcmStatuses.CCMPatientRefusedCoPayInsurance,
  CcmStatuses.CCMPatientRefusedExpired,
  CcmStatuses.CCMPatientRefusedChangedDoctor,
  CcmStatuses.CCMPatientRefusedNotInterestedNotNecessarySuspectScam,
  CcmStatuses.CCMPatientRefusedWrongContactInformation,
  CcmStatuses.CCMPatientRefusedNoContact,
  CcmStatuses.CCMPatientRefusedOther,
  CcmStatuses.CCMPatientRefusedWantsToDiscussWithPhysician,
];

export const disableRpmModuleStatuses = [
  RpmStatuses.PatientReferral,
  RpmStatuses.ReferralOnHold,
  RpmStatuses.ReferralWithdrawn,
  RpmStatuses.CallingQueue,
  RpmStatuses.OnboardingUnsuccessful,
  RpmStatuses.PatientNoContact,
  RpmStatuses.PatientRefusedConnectivityOrTechBarier,
  RpmStatuses.PatientRefusedCopayInsurance,
  RpmStatuses.PatientRefusedNotInterestedNotNecessarySuspectScam,
  RpmStatuses.PatientRefusedExpired,
  RpmStatuses.PatientRefusedThereIsNoOneToHelp,
  RpmStatuses.PatientRefusedHasANewPhysician,
  RpmStatuses.PatientRefusedWantsToDiscussWithPhysician,
  RpmStatuses.PatientRefusedWrongContactInformation,
  RpmStatuses.InsuranceRefused,
];

export const readonlyCcmModuleStatuses = [
  CcmStatuses.CCMOnboardingUnsuccessfulNoContact,
  CcmStatuses.CCMOnboardingUnsuccessfulPatientRefused,
  CcmStatuses.CCMOnboardingUnsuccessfulPatientNotQualifiedForCCM,
  CcmStatuses.CCMOnboardingUnsuccessfulChangedDoctor,
  CcmStatuses.CCMOnboardingUnsuccessfulOther,
  CcmStatuses.CCMUnenrolledChangedDoctor,
  CcmStatuses.CCMUnenrolledClientRequest,
  CcmStatuses.CCMUnenrolledCopayLossOfInsurance,
  CcmStatuses.CCMUnenrolledNonAdherent,
  CcmStatuses.CCMUnenrolledExpired,
  CcmStatuses.CCMUnenrolledHospice,
  CcmStatuses.CCMUnenrolledLongTermSkilledNursingFacilityRehab,
  CcmStatuses.CCMUnenrolledPhysicianClinicRequest,
  CcmStatuses.CCMUnenrolledClientRequestMoving,
  CcmStatuses.CCMUnenrolledHealthPlanRequestGoalsMet,
  CcmStatuses.CCMUnenrolledOther,
];

export const readonlyRpmModuleStatuses = [
  RpmStatuses.InactiveBadNoSignalConnectivity,
  RpmStatuses.InactiveChangedDoctor,
  RpmStatuses.InactiveClientRequestInconvenient,
  RpmStatuses.InactiveClientRequestMoving,
  RpmStatuses.InactiveClientRequestOther,
  RpmStatuses.InactiveExpired,
  RpmStatuses.InactiveHealthPlanRequestGoalsMet,
  RpmStatuses.InactiveHealthPlanRequestNonCompliant,
  RpmStatuses.InactiveHealthPlanRequestOther,
  RpmStatuses.InactiveHospice,
  RpmStatuses.InactiveCopay,
  RpmStatuses.InactiveLongTermCareRehab,
  RpmStatuses.InactiveLossOfEligibility,
  RpmStatuses.InactivePhysicianRequest,
];

export const patientPageAccessRpmStatuses = [
  RpmStatuses.Active,
  RpmStatuses.Onboarding,
  RpmStatuses.PendingReview,
  RpmStatuses.Inactive,
  RpmStatuses.InactiveBadNoSignalConnectivity,
  RpmStatuses.InactiveChangedDoctor,
  RpmStatuses.InactiveClientRequestInconvenient,
  RpmStatuses.InactiveClientRequestMoving,
  RpmStatuses.InactiveClientRequestOther,
  RpmStatuses.InactiveExpired,
  RpmStatuses.InactiveHealthPlanRequestGoalsMet,
  RpmStatuses.InactiveHealthPlanRequestNonCompliant,
  RpmStatuses.InactiveHealthPlanRequestOther,
  RpmStatuses.InactiveHospice,
  RpmStatuses.InactiveCopay,
  RpmStatuses.InactiveLongTermCareRehab,
  RpmStatuses.InactiveLossOfEligibility,
  RpmStatuses.InactivePhysicianRequest,
];

export const patientPageAccessCcmStatuses = [
  CcmStatuses.Enrolled,
  CcmStatuses.CCMOnboarding,
  CcmStatuses.CCMOnboardingUnsuccessfulNoContact,
  CcmStatuses.CCMOnboardingUnsuccessfulPatientRefused,
  CcmStatuses.CCMOnboardingUnsuccessfulPatientNotQualifiedForCCM,
  CcmStatuses.CCMOnboardingUnsuccessfulChangedDoctor,
  CcmStatuses.CCMOnboardingUnsuccessfulOther,
  CcmStatuses.CCMUnenrolledChangedDoctor,
  CcmStatuses.CCMUnenrolledClientRequest,
  CcmStatuses.CCMUnenrolledCopayLossOfInsurance,
  CcmStatuses.CCMUnenrolledNonAdherent,
  CcmStatuses.CCMUnenrolledExpired,
  CcmStatuses.CCMUnenrolledHospice,
  CcmStatuses.CCMUnenrolledLongTermSkilledNursingFacilityRehab,
  CcmStatuses.CCMUnenrolledPhysicianClinicRequest,
  CcmStatuses.CCMUnenrolledClientRequestMoving,
  CcmStatuses.CCMUnenrolledHealthPlanRequestGoalsMet,
  CcmStatuses.CCMUnenrolledOther,
];
